import { useState, useRef, ChangeEvent, useCallback } from "react";
import { useMutation } from "@tanstack/react-query";
import { qClient } from "../../../../index";
import {
    displayError,
    displaySuccessMessage,
} from "../../../services/Notifications/NotificationServices";

export default function useImageUpload(
    uploadFn: (file: File) => Promise<string>,
    initialUrl = "",
    queryKey: string[],
) {
    const [imageUrl, setImageUrl] = useState(initialUrl);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const onSuccess = useCallback(
        async (url: string) => {
            if (!url) {
                displayError("Ошибка: пустой URL изображения");
                return;
            }
            setImageUrl(`${url}?t=${Date.now()}`);

            await qClient.invalidateQueries({
                queryKey
            });
            displaySuccessMessage("Изображение загружено");
        },
        [queryKey]
    );
    const mutation = useMutation({
        mutationFn: uploadFn,
        onSuccess,
        onError: (e: any) => {
            displayError("Ошибка при получении изображения");
            console.error(e);
        },
    });

    // Для <input type="file" ref = ... /> в ProfileImages
    const handleFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;
        mutation.mutate(file);
    };

    // Для ThumbnailPicker
    const uploadFile = async (file: File) => {
        mutation.mutate(file);
    };

    return {
        imageUrl,
        setImageUrl,
        fileInputRef,
        handleFileChange,
        uploadFile,
    };
}
